import script from "./Fleet.vue?vue&type=script&setup=true&lang=js"
export * from "./Fleet.vue?vue&type=script&setup=true&lang=js"

import "./Fleet.vue?vue&type=style&index=0&id=2a38edd8&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a38edd8"]])

export default __exports__